let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("brrrb")).then(() => parcelRequire('fKvyc'));